export default __webpack_public_path__ + "static/media/image (3)@2x.2e347d7f.png";